/**
 * Подстановка в строку словаря: `fillTemplate('Заявки: {count}', { count: 3 })`.
 *
 * <p>Все вхождения, а не первое (`String.replace` со строкой меняет только первое): «Удалить чат
 * с {name}? … если {name} напишет» иначе показала бы человеку фигурные скобки во второй половине.
 */
export function fillTemplate(template: string, vars: Record<string, string | number>): string {
  return template.replace(/\{(\w+)}/g, (whole, key: string) =>
    Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : whole,
  );
}
